import { useTranslation } from 'react-i18next';

import { useAuthStore } from '@/app/store/auth.store';
import { MyProfileInfoCard } from '@/features/my-profile/components/MyProfileInfoCard';
import { PasswordChangeCard } from '@/features/my-profile/components/PasswordChangeCard';
import { RootTransferEntryCard } from '@/features/my-profile/components/RootTransferEntryCard';
import { useMyProfileQuery } from '@/features/my-profile/hooks/use-my-profile';

// PRD 20 §2.1 — 3-card layout, max-width 720px, 24px padding, 24px gap.
export function MyProfilePage() {
  const { t } = useTranslation('my-profile');
  const { data: profile, isLoading, isError } = useMyProfileQuery();
  // Card 3 visibility follows the live auth-store value rather than a value read
  // once at login: SHCT-629 re-applies the server's answer on every navigation,
  // so a Root grant or revocation lands here without a re-fetch of /auth/me.
  const isRoot = useAuthStore((s) => s.isRoot);

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{t('page.title')}</h1>
        </div>
      </div>
      <div className="content__body">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 24,
            maxWidth: 720,
          }}
        >
          {isLoading && (
            <p style={{ color: 'var(--muted-foreground)', margin: 0 }}>
              {t('states.loading')}
            </p>
          )}

          {isError && (
            <div
              className="card"
              role="alert"
              style={{
                padding: 24,
                color: '#991b1b',
                background: '#fee2e2',
                borderLeft: '4px solid var(--destructive)',
              }}
            >
              {t('states.error')}
            </div>
          )}

          {profile && <MyProfileInfoCard profile={profile} />}

          {profile && (
            <PasswordChangeCard passwordChangedAt={profile.passwordChangedAt} />
          )}

          {isRoot && <RootTransferEntryCard />}
        </div>
      </div>
    </>
  );
}
